import { ScheduledReportDateRangeEndEnum } from "@enums/scheduledReportDateRangeEnd.enum";
import { ScheduledReportDateRangeStartEnum } from "@enums/scheduledReportDateRangeStart.enum";
import { ScheduledReportReportTypeEnum } from "@enums/scheduledReportReportType.enum";
import { ScheduledReportScheduleTypeEnum } from "@enums/scheduledReportScheduleType.enum";
import { ScheduledReportSingleDayEnum } from "@enums/scheduledReportSingleDay.enum";
import { Model } from "@interfaces/model.interface";

export interface ScheduledReport extends Model {
	cronString: string;
	dateRangeEndDays: number;
	dateRangeEndType: ScheduledReportDateRangeEndEnum;
	dateRangeStartDays: number;
	dateRangeStartType: ScheduledReportDateRangeStartEnum;
	enabled: boolean;
	lastRunDate?: Date;
	name: string;
	nextRunDate?: Date;
	reportType: ScheduledReportReportTypeEnum;
	scheduleDay: number;
	scheduleDescription: string;
	scheduleTime: string;
	scheduleType: ScheduledReportScheduleTypeEnum;
	singleDateDays: number;
	singleDateType: ScheduledReportSingleDayEnum;
	siteId: number;
	siteIds: string;
	siteIdsSelection: number[];
	userProfileId: number;
}

export class ScheduledReport implements ScheduledReport {
	scheduleTime = "00:30";

	constructor(data?: Partial<ScheduledReport>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}